var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSocialMediaYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_in_Pfaden"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Arrow"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Social-Media"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M18,5.3c2.2,0,4.4,0,6.5,0.1c2.1,0.1,3.6,0.1,4.6,0.2l1.5,0.1c0,0,0.1,0,0.3,0c0.2,0,0.4,0,0.5,0.1 c0.1,0,0.3,0.1,0.5,0.1c0.2,0,0.4,0.1,0.6,0.2c0.2,0.1,0.3,0.2,0.6,0.3c0.2,0.1,0.4,0.2,0.6,0.4C33.8,6.9,34,7,34.2,7.2 c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.2,0.3,0.6,0.6,1.2c0.3,0.6,0.4,1.3,0.5,2c0.1,0.9,0.2,1.8,0.3,2.7c0.1,1,0.1,1.7,0.1,2.3v3.5 c0,1.9-0.1,3.9-0.4,5.8c-0.1,0.7-0.3,1.4-0.5,2c-0.2,0.6-0.5,1-0.6,1.2l-0.3,0.3c-0.2,0.2-0.4,0.4-0.6,0.5 c-0.2,0.2-0.4,0.3-0.6,0.4s-0.4,0.2-0.6,0.3c-0.2,0.1-0.4,0.1-0.6,0.2c-0.2,0-0.4,0.1-0.5,0.1c-0.1,0-0.3,0-0.5,0.1 c-0.2,0-0.3,0-0.3,0c-3.4,0.3-7.6,0.4-12.6,0.4c-2.8,0-5.2-0.1-7.2-0.1c-2-0.1-3.4-0.1-4-0.2l-1-0.1L5,30.2 c-0.5-0.1-0.8-0.1-1.1-0.2c-0.2-0.1-0.6-0.2-1-0.4c-0.4-0.2-0.8-0.5-1.1-0.8c-0.1-0.1-0.2-0.2-0.3-0.4s-0.3-0.6-0.6-1.2 s-0.4-1.3-0.5-2c-0.1-0.9-0.2-1.8-0.3-2.7c-0.1-1-0.1-1.7-0.1-2.3v-3.5c0-1.9,0.1-3.9,0.4-5.8c0.1-0.7,0.3-1.4,0.5-2s0.5-1,0.6-1.2 l0.3-0.3C2,7,2.2,6.9,2.4,6.7C2.6,6.5,2.8,6.4,3,6.3C3.2,6.2,3.4,6.1,3.6,6C3.7,6,3.9,5.9,4.1,5.9c0.2,0,0.4-0.1,0.5-0.1 c0.1,0,0.2,0,0.5-0.1c0.2,0,0.3,0,0.3,0C8.8,5.5,13,5.3,18,5.3L18,5.3z M14.3,22.7l9.7-5l-9.7-5.1V22.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialMediaYoutube);
export default __webpack_public_path__ + "static/media/icon-social-media-youtube.8b6f4af09aa467833c76ccd6ef1cf56e.svg";
export { ForwardRef as ReactComponent };